export default __webpack_public_path__ + "static/touch-ad0d40c1291111cd042c1122816ce085.webp";